import Breadcrumb from "components/Common/Breadcrumb"
import NewPagination from "components/Common/Newpagination"
import React, { useEffect, useMemo, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table"
import {
  Card,
  CardBody,
  Col,
  Container,
  DropdownMenu,
  DropdownToggle,
  Form,
  Input,
  Label,
  Modal,
  Row,
  Table,
  UncontrolledDropdown,
} from "reactstrap"
import Select from "react-select"
import configure from "configure"
import Swal from "sweetalert2"
import Icon from "../../../assets/images/users/AdminImg.png"
import axios from "axios"
import moment from "moment"
import Loader from "pages/Separate/Loader"
import { getInitials } from "utils/common-helpers"

function TableContainer({ columns, data, setAccessDenied, setLoading }) {
  const [fixedHeader, setFixedHeader] = useState(false)
  const [fixedContent, setFixedContent] = useState(false)
  const [reportFilter, setReportFilter] = useState(false)

  document.addEventListener("scroll", () => {
    const scrollThreshold = window.innerHeight * 0.25
    if (window.scrollY > scrollThreshold) {
      setFixedContent(true)
    } else {
      setFixedContent(false)
    }
  })

  document.addEventListener("keydown", e => {
    if (e.key == "Escape") {
      setReportFilter(false)
    }
  })
  const navigate = useNavigate()
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,

      initialState: {
        pageSize: 50,
        sortBy: [
          {
            id: "id",
            desc: true,
          },
        ],
      },
    },

    useGlobalFilter,
    useSortBy,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedHeader(true)
    } else {
      setFixedHeader(false)
    }
  })

  return (
    <div>
      {/* fixed buttons */}
      <div
        className={`flex-column fixed-buttons pt-2 ${
          fixedContent ? "d-flex" : "d-none"
        }`}
      >
        <Link
          className="btn btn-save  fix-btn btn-label pe-0"
          onClick={() => navigate(`${configure.appUrl}add-case-study`)}
        >
          <i className="fas fa-plus me-2 icon-size label-icon"></i>
          <span>Case Study</span>
        </Link>
        <button
          onClick={() => navigate(-1)}
          className="btn btn-red  fix-btn btn-label pe-0"
          type="button"
        >
          <i className="dripicons-cross me-2 icon-center label-icon"></i>
          <span>Cancel</span>
        </button>
      </div>
      <Row className="mb-2">
        <Col md={3}>
          <div>
            <select
              className=" form-select"
              style={{ width: "100px" }}
              value={pageSize}
              onChange={e => setPageSize(e.target.value)}
            >
              {[10, 25, 50, 100].map(pageSize => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select>
          </div>
        </Col>
        <Col md={9} className="d-flex justify-content-end">
          <div className="me-2 d-flex">
            {/* <div className="mb-2">
              <button
                onClick={() => setReportFilter(!reportFilter)}
                className="btn btn-outline-secondary  me-3"
              >
                <i className="fas fa-filter"></i>
              </button>
            </div> */}
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={e => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className=" form-control rounded h-100"
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div className="text-md-end ">
            <div className="d-flex gap-2">
              <a
                className=" btn btn-save btn-label ms-md-2"
                onClick={() => navigate(`${configure.appUrl}add-case-study`)}
              >
                <i className="fas fa-plus me-2 label-icon"></i>
                Case Study
              </a>
              <a
                onClick={() => navigate(-1)}
                className=" btn ms-md-2 btn-red btn-label"
                type="button"
              >
                <i className="dripicons-cross me-2 icon-center label-icon"></i>
                CANCEL
              </a>
            </div>
          </div>
        </Col>
      </Row>
      <Table className="table table-bordered mt-4 shadow" {...getTableProps()}>
        <thead
          className={`${
            fixedHeader && page.length >= 10 ? "fix-staffs-headers" : ""
          } fix-staff-headers`}
        >
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <th
                  key={index}
                  className={`t-col-${index + 1} ${
                    column.className
                  } customShortIcon`}
                  {...column.getHeaderProps()}
                >
                  {column.render("Header")}
                  {column.isShortIcon && (
                    <span
                      onClick={e => column.getSortByToggleProps().onClick(e)}
                      className="ms-2 cursor-pointer"
                    >
                      <i
                        title="Ascending"
                        className={`bi bi-arrow-up info-icon ${
                          column.isSorted && !column.isSortedDesc
                            ? "text-dark"
                            : ""
                        }`}
                      ></i>
                      <i
                        title="Descending"
                        className={`bi bi-arrow-down info-icon ${
                          column.isSorted && column.isSortedDesc
                            ? "text-dark"
                            : ""
                        }`}
                      ></i>
                    </span>
                  )}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody className={`fix-staff-headers`} {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <tr
                className={`row-hover ${
                  row?.original?.chance ? "bg-orange" : ""
                }`}
                {...row.getRowProps()}
                key={i}
              >
                {row.cells.map((cell, index) => {
                  return (
                    <td
                      key={index}
                      className={`t-col-${index + 1}`}
                      {...cell.getCellProps()}
                    >
                      {cell.render("Cell")}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </Table>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <NewPagination
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
        />
      </Row>

      {/* {reportFilter ? (
        <div className="inv_report_filter">
          <Form>
            <Row className="align-items-end">
              <Row className="d-flex flex-wrap justify-space-between">
                <div className="col-8 d-flex gap-3">
                  <div className="col-3 mt-2">
                    <label htmlFor="">From Date</label>
                    <Input
                      type="date"
                      className="form-control"
                      id="formrow-firstname-Input"
                      placeholder="Enter Task Name"
                      required
                    />
                  </div>
                  <div className="col-3 mt-2">
                    <label htmlFor="">To Date</label>
                    <Input
                      type="date"
                      className="form-control"
                      id="formrow-firstname-Input"
                      placeholder="Enter Task Name"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-3 d-flex gap-2 justify-content-end align-items-end mb-2 pe-0 ps-0">
                  <a
                    className="btn  btn-danger me-1"
                    style={{
                      fontSize: "14px",
                      backgroundColor: "#fed36d",
                      borderColor: "#fed36d",
                      color: "black",
                    }}
                    onClick={() => {}}
                  >
                    Clear Filters
                  </a>
                  <button className="btn  btn-save btn-label me-1">
                    <i className="fas fa-filter search-icon label-icon"></i>{" "}
                    Filter
                  </button>
                  <a
                    className="btn btn-red btn-label me-1"
                    onClick={() => setReportFilter(false)}
                  >
                    <i className="dripicons-cross label-icon"></i> Close
                  </a>
                </div>
              </Row>
            </Row>
          </Form>
        </div>
      ) : null} */}
    </div>
  )
}

const CaseStudy = () => {
  const [datas, setData] = useState([])
  const [isLoading, setLoading] = useState(false)
  const [change, setChange] = useState(false)
  const [editReport, setEditReport] = useState(false)
  const [discardPopup, setDiscardPopup] = useState(false)

  const navigate = useNavigate()

  document.title = "Case Study | Zithas Crm"

  useEffect(() => {
    fetchNodeData()
  }, [])

  async function fetchNodeData() {
    setLoading(true)
    axios
      .get(`${configure.nodeApi}/case-study`)
      .then(res => {
        setLoading(false)
        setData(res?.data?.caseStudy)
      })
      .catch(e => {
        setLoading(false)
        console.log(e)
      })
  }

  const ondelete = id => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this case study?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#762C99",
      cancelButtonColor: "#BF1E30",
      confirmButtonText: "Yes, delete it!",
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          setLoading(true)
          const res = await axios.delete(
            `${configure.nodeApi}/case-study/${id}`
          )
          if (res?.data?.success) {
            Swal.fire("Deleted!", "The case study has been deleted.", "success")
            fetchNodeData()
          }
        } catch (e) {
          Swal.fire("Error", "Something Went Wrong", "error")
        }
      }
    })
  }

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        className: "iv_id",
        Cell: cellProps => (
          <div className="text-center">{cellProps.row.original.id}</div>
        ),
      },
      {
        Header: "Project",
        accessor: "project_name",
        className: "iv_name",
        Cell: cellProps => (
          <div className="d-flex align-items-center gap-2">
            {cellProps?.row?.original?.avatar ? (
            <div className="profileImg-box">
              <img
                src={`${
                  cellProps?.row?.original?.avatar
                    ? `${configure.imgUrl}${cellProps?.row?.original?.avatar}`
                    : Icon
                }`}
                alt=""
                className="assigned-img mx-1"
                height="20"
                width="20"
                title={cellProps?.row?.original.alias_name}
              ></img>
            </div>
            ) : (
              <div
                className="defualt-img" title={cellProps?.row?.original.alias_name}>
                  {getInitials(cellProps?.row?.original?.alias_name || "Z")}
              </div>
            )}
            <div>{cellProps?.row?.original?.project_name}</div>
          </div>
        ),
      },
      {
        Header: "Technology",
        accessor: "technology",
        // className: "iv_name",
        Cell: cellProps => (
          <div>
            {cellProps?.row?.original?.technologies?.map((obj, i, arr) => (
              <span className="" key={i}>
                {obj}
                {i < arr.length - 1 ? ", " : ""}
              </span>
            ))}
          </div>
        ),
      },
      {
        Header: "Service",
        accessor: "services",
        // className: "iv_code",
      },
      {
        Header: "Website",
        accessor: "website",
        // className: "iv_code",
      },
      {
        Header: "Created At",
        accessor: "createdAt",
        className: "col-md-1",
        Cell: ({ value }) => (value ? moment(value).format("DD/MM/YYYY") : "-"),
      },

      {
        Header: "Action",
        accessor: "action",
        className: "iv_code",
        Cell: cellProps => (
          <div className="text-center">
            <a
              onClick={() =>
                navigate(
                  `${configure.appUrl}view-case-study/${cellProps?.row?.original?.id}`
                )
              }
              className="btn btn-sm me-1 btn-outline-secondary"
              title="View Case Study"
            >
              <i className="fas fa-eye"></i>
            </a>
            <a
              onClick={() =>
                navigate(
                  `${configure.appUrl}edit-case-study/${cellProps?.row?.original?.id}`
                )
              }
              className="btn btn-sm me-1 btn-outline-secondary"
              title="Edit Case Study"
            >
              <i className="fas fa-pencil-alt"></i>
            </a>
            <a
              onClick={() => ondelete(cellProps?.row?.original?.id)}
              className="btn btn-sm me-1 btn-outline-danger"
              title="Delete Case Study"
            >
              <i className="bi bi-trash"></i>
            </a>
          </div>
        ),
      },
    ],
    []
  )

  return (
    <div>
      {isLoading && <Loader />}
      <React.Fragment>
        <div className="page-content" id="staff">
          <Container fluid>
            <Breadcrumb
              title={"Dashboard"}
              breadcrumbItem={"Project Case Studies"}
            />
            <Row>
              <Col lg={12} className="p-0">
                <Card>
                  <CardBody>
                    <div className="responsive-table">
                      <TableContainer
                        columns={columns}
                        data={datas}
                        setLoading={setLoading}
                        navigate={navigate}
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    </div>
  )
}

export default CaseStudy
